module.exports = __webpack_public_path__ + "img/108.2a8f8556.png";